export const SORT_DIRECTIONS = {
  asc: 'asc',
  desc: 'desc',
};
